import { useSelector } from 'react-redux';
import { TcsmStates } from '../../root/tcsm-model';
import { getBasePath } from '../helpers/routing';
import { GlobalizationState } from '../models/globalization-model';

export function useBasePath(appBaseName: string) {
    const globalization = useSelector<TcsmStates, GlobalizationState>(state => state.globalization);

    if ((window as any)?.bootstrap?.spaBasePath){
        return `${(window as any)?.bootstrap?.spaBasePath}/${appBaseName}`;
    }
    return getBasePath(globalization?.currentlanguage, appBaseName);
}

